import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import CircularProgress from '@mui/material/CircularProgress';
import { API } from 'Amplify';

type FleetActionsImagesProps = {
  admin: boolean;
};

export function FleetsActionsImages(props: FleetActionsImagesProps) {
  const [loadingImages, setLoadingImages] = useState(false);
  const [imageList, setImageList] = useState([]);
  const [loadingImageURL, setLoadingImageURL] = useState(false);
  const [downloadImage, setDownloadImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [selectedImageURL, setSelectedImageURL] = useState(null);
  const [images, setImages] = useState(false);

  let selectImages: JSX.Element[];
  let imgSelect: JSX.Element | null = null;

  useEffect(() => {
    if (images) {
      setLoadingImages(true);
      API.get('IO_API', `/files/releases`, { headers: { 'Content-Type': 'application/json' } })
        .then((res) => {
          setImageList(res);
        })
        .catch((e) => {
          console.log('GOT ERROR', e);
        })
        .finally(() => {
          setLoadingImages(false);
        });
    } else {
      setImageList([]);
      setSelectedImage('');
    }
  }, [images]);

  useEffect(() => {
    if (downloadImage && selectedImageURL) {
      window.location.assign(selectedImageURL);
      setDownloadImage(false);
    }
  }, [downloadImage, selectedImageURL]);

  useEffect(() => {
    if (selectedImage) {
      setLoadingImageURL(true);
      API.get('IO_API', `/files/releases/${selectedImage}`, { headers: { 'Content-Type': 'application/json' } })
        .then(({ url }) => setSelectedImageURL(url))
        .catch((e) => console.log('ERROR', e))
        .finally(() => setLoadingImageURL(false));
    }
  }, [selectedImage]);

  if (props.admin) {
    selectImages = imageList.map(({ value, label }) => (
      <MenuItem
        key={value}
        value={value}
      >
        {label}
      </MenuItem>
    ));

    imgSelect =
      imageList.length > 0 ? (
        <FormControl fullWidth>
          <InputLabel>Build Image</InputLabel>
          <Select
            value={selectedImage}
            input={<OutlinedInput label="Build Image" />}
            onChange={(ev, _v) => setSelectedImage(ev.target.value)}
          >
            {selectImages}
          </Select>
        </FormControl>
      ) : (
        <div>No images found</div>
      );
  }

  return (
    <>
      {props.admin ? (
        <Button
          variant="outlined"
          style={{ backgroundColor: '#ffffff' }}
          onClick={() => setImages(true)}
        >
          Images
        </Button>
      ) : null}

      <Dialog
        onClose={() => setImages(false)}
        open={images}
      >
        <DialogTitle>Download Images</DialogTitle>
        <DialogContent sx={{ overflow: 'visible', pt: 2 }}>{loadingImages ? <CircularProgress /> : imgSelect}</DialogContent>
        <DialogActions>
          <Button
            disabled={!Boolean(selectedImage)}
            onClick={() => setDownloadImage(true)}
          >
            {loadingImageURL ? <CircularProgress /> : 'Download'}
          </Button>
          <Button onClick={() => setImages(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
